import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=f08d4ec6&scoped=true&"
import script from "./InformationList.vue?vue&type=script&lang=js&"
export * from "./InformationList.vue?vue&type=script&lang=js&"
import style0 from "./InformationList.vue?vue&type=style&index=0&id=f08d4ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08d4ec6",
  null
  
)

export default component.exports